// src/hooks/useTelegram.js
import { useEffect, useState, useMemo } from 'react';

const makeStub = () => {
    const noop = () => {};
    return {
        initData: '',
        initDataUnsafe: { user: null, start_param: '' },
        ready: noop,
        expand: noop,
        requestFullscreen: noop,
        exitFullscreen: noop,
        setHeaderColor: noop,
        setBackgroundColor: noop,
        themeParams: { bg_color: '#18181A' },
        BackButton: { show: noop, hide: noop, onClick: noop, offClick: noop },
        SettingsButton: { show: noop, hide: noop, onClick: noop, offClick: noop },
        close: noop,
        supports: () => false,
    };
};

export default function useTelegram() {
    // сразу заводим stub, чтобы tg !== null
    const [tg, setTg] = useState(makeStub());

    useEffect(() => {
        const webApp = window.Telegram?.WebApp;

        // если нет WebApp или initData — остаёмся на stub
        if (!webApp || !webApp.initData) {
            console.log('🔧 useTelegram: не в Telegram Mini App, остаёмся на stub');
            return;
        }

        // реальный Telegram Mini App
        webApp.ready();
        webApp.expand();

        const desktopPlatforms = ['tdesktop', 'macos', 'web', 'weba'];
        const isDesktop = desktopPlatforms.includes(webApp.platform);

        if (!isDesktop && typeof webApp.requestFullscreen === 'function') {
            try {
                webApp.requestFullscreen();
            } catch (e) {
                console.warn('requestFullscreen failed:', e);
            }
        }

        if (typeof webApp.lockOrientation === 'function') {
            try {
                webApp.lockOrientation('portrait');
            } catch (e) {
                console.warn('⚠️ lockOrientation failed:', e);
            }
        }

        webApp.BackButton.show();
        webApp.SettingsButton.show();

        try {
            webApp.setHeaderColor('#000000');
            webApp.setBackgroundColor('#000000');
        } catch (e) {
            const bg = webApp.themeParams?.bg_color;
            if (bg) {
                webApp.setHeaderColor(bg);
                webApp.setBackgroundColor(bg);
            }
        }

        setTg(webApp);
    }, []);

    // читаем параметр старта из Telegram
    const startParam = tg?.initDataUnsafe?.start_param || '';

    // Парсим start_param. Два формата суффикса промо:
    //   ref_<code>_promo<id> — ссылка промоутера (PROMO_PROMOTION)
    //   ref_<code>_p<id>     — ссылка-приглашение участника (PROMO_INVITATION)
    // Пример: ref_bQI-nmZwnt0_p23 → refCode: bQI-nmZwnt0, promoId: 23
    const { refCode, promoId } = useMemo(() => {
        if (!startParam) return { refCode: '', promoId: null };

        // Убираем ref_ префикс если есть
        const withoutPrefix = startParam.startsWith('ref_')
            ? startParam.slice(4)
            : startParam;

        // Ищем _promo<id> или _p<id> в конце
        const promoMatch = withoutPrefix.match(/_(?:promo|p)(\d+)$/);

        if (promoMatch) {
            // Есть promoId
            const promoIdNum = parseInt(promoMatch[1], 10);
            const code = withoutPrefix.replace(/_(?:promo|p)\d+$/, '');
            return { refCode: code, promoId: promoIdNum };
        }

        // Только refCode без promoId
        return { refCode: withoutPrefix, promoId: null };
    }, [startParam]);

    return { ...tg, startParam, refCode, promoId };
}
